import version from '@/version'
// eslint-disable-next-line no-console
console.log(Object.entries(version).filter(([k, v]) => v).map(t => t.join(':')).join(', '))
